import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const CTASection = ({
  eyebrow = "Ready to build?",
  title = "Let's design something that lasts.",
  body = "Share your project, showroom shell, or dealership enquiry — we'll take it from there.",
  primaryLabel = "Contact Us",
  primaryTo = "/contact",
  secondaryLabel = "Become a Dealer",
  secondaryTo = "/become-a-dealer",
  testid = "cta-section",
}) => {
  return (
    <section data-testid={testid} className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-8 reveal">
          <div className="overline text-gold">{eyebrow}</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-4 font-light">
            {title}
          </h2>
          <p className="mt-5 text-white/75 text-base md:text-lg max-w-xl leading-relaxed">{body}</p>
        </div>
        <div className="md:col-span-4 flex flex-col gap-3 md:items-end reveal">
          <Link
            to={primaryTo}
            data-testid={`${testid}-primary`}
            className="inline-flex items-center gap-3 bg-coral hover:bg-[#d66a54] text-white px-7 py-3.5 tracking-wide transition-colors group"
          >
            <span>{primaryLabel}</span>
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </Link>
          <Link
            to={secondaryTo}
            data-testid={`${testid}-secondary`}
            className="inline-flex items-center gap-3 border border-white/40 hover:border-gold hover:text-gold text-white px-7 py-3.5 tracking-wide transition-colors"
          >
            <span>{secondaryLabel}</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
